import { useState } from 'react';
import { ManualHighSchoolCertificateForm } from './ManualHighSchoolCertificateForm';
import { PersonaHighSchoolVerification } from './PersonaHighSchoolVerification';
import { Application } from '../../types';

interface EducationVerificationModalProps {
  close: () => void;
  referenceId: string;
  application: Application;
}

export const EducationVerificationModal = ({
  close,
  application,
}: EducationVerificationModalProps) => {
  // Check if user has already chosen a verification mode
  const hasChosenManual = application.highSchoolVerificationMode === 'MANUAL';
  const hasChosenPersona = application.highSchoolVerificationMode === 'PERSONA';

  const [showManualForm, setShowManualForm] = useState(hasChosenManual);

  if (showManualForm) {
    return (
      <ManualHighSchoolCertificateForm
        programApplicationId={application.id}
        close={close}
      />
    );
  }

  return (
    <PersonaHighSchoolVerification
      programApplicationId={application.id}
      close={close}
      hasChosenPersona={hasChosenPersona}
      onSwitchToManual={() => setShowManualForm(true)}
    />
  );
};
